// @flow

import * as React from 'react';

import Constants from '../Constants';

export const Place = (props: { place: number }) => {
  const classes = ['background-place'];
  if (props.place === Constants.PLACE_ZOO) {
    classes.push('background-place-zoo');
  } else if (props.place === Constants.PLACE_OFFICE_STREAT) {
    classes.push('background-place-office');
  } else if (props.place === Constants.PLACE_SHOPPING_MALL) {
    classes.push('background-place-shop');
  }
  return <div className={classes.join(' ')} />;
};
